import { Lang } from './keys';

const { location } = window;
const { document } = window;

export const docs = location.pathname.startsWith('/docs/');
export const error = window.urlError === true;
export const { lang } = document.documentElement;
export const microsite = /^\/(developer|events|landing|overview|tools|welcome)/.test(location.pathname);
export const render = window.requestAnimationFrame;
export const root =
  location.host === 'experienceleague-local.adobe.com' ? location.pathname === '/' : location.pathname === '/home';

export function locale() {
  sessionStorage.setItem(Lang, lang);
}
